import { useEffect, type PropsWithChildren } from "react"

import { fetchInsightsData } from "../actions/insights"
import { updateUserInfo } from "../actions/users"
import useConfiguration from "@/hooks/use_configuration"
import Loading from "@/organism/loading"
import { useAppDispatch, useAppSelector } from "@/lib/hooks"

const DataLoader = ({ children }: PropsWithChildren) => {
  const auth = useAppSelector((s) => s.auth)
  const configuration = useAppSelector((s) => s.configuration)
  const insightsEnabled = configuration?.insightsEnabled
  const dispatch = useAppDispatch()
  const token = auth?.token
  const [, , configurationError] = useConfiguration()

  useEffect(() => {
    if (token) void dispatch(updateUserInfo())
  }, [token, dispatch])

  useEffect(() => {
    if (auth?.user && insightsEnabled) {
      void dispatch(fetchInsightsData())
    }
  }, [auth, insightsEnabled, dispatch])

  if (!configuration) {
    if (configurationError) return null
    return <Loading />
  }

  return children
}

export default DataLoader
